// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Tp-z","imageAndVideoCount":"Up-z","imageAndVideoContainer":"Vp-z","viewAllReviews":"Wp-z"};